import { useEffect, useRef, useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import Loader from "../component/Loader";
import { useHandleError } from "../hooks/useHandleError";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import MessageToster from "../component/MessageToster";
import useIbStatus from "../hooks/useIbStatus";
import { exportToExcel } from "../utils/exportData";
import MobileFilter from "../component/MobileFilter";
import ExportButton from "../component/ExportButton";

export default function IbCommissionReport() {
    const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
    const handleError = useHandleError();
    const mid = sessionStorage.getItem("mid");
    const [loading, setLoading] = useState(false);
    const [ibCommissionData, setIbCommissionData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [accounts, setAccounts] = useState([]);
    const [clientIds, setClientIds] = useState([]);
    const [noTableData, setNoTableData] = useState(true);
    const {
        ibStatus,
        ibLoading,
        isActive,
        isPending,
        isNotApplied
    } = useIbStatus();

    const isPageLoading = ibLoading || loading;

    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        account: "",
        clientId: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const clearFilters = () => {
        setFilters({
            fromDate: "",
            toDate: "",
            account: "",
            clientId: ""
        });
        setSearchTerm("");
        setSearchQuery("");
        setAccounts([]);
        setIbCommissionData([]);
        setNoTableData(true);
    };


    const handleClientSelect = (clientId) => {
        setFilters(prev => ({
            ...prev,
            clientId,
            account: ""
        }));

        setIbCommissionData([]);

        const selected = clientIds.find(c => c.client_id === clientId);

        if (selected && selected.mt5_accounts) {
            setAccounts(selected.mt5_accounts);
        } else {
            setAccounts([]);
        }
    };

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = async () => {
        try {
            setLoading(true);
            const inputBody = {};
            // const inputBody = { mode: "", mid: Number(mid) };
            const res = await axios.get(`${BASE_URL}/IB/ib_clients_and_mt_accounts_data`, { headers: getApiHeaders() });

            if (res.data.code === 200) {
                const clients = res.data.data.clients;
                setClientIds(clients);

            } else {
                MessageToster("error", "Failed to fetch client list");
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     if (isActive) {
    //         getIbCommissionData();
    //     }
    // }, [isActive]);

    const getIbCommissionData = async () => {

        if (!filters.clientId) {
            return MessageToster("error", "Please select client");
        }
        if (!filters.account) {
            return MessageToster("error", "Please select account number");
        }
        setLoading(true);
        const inputBody = {
            mode: "",
            // mid: Number(mid),
            clientid: filters.clientId.toString(),
            account_number: Number(filters.account),
            fromdate: filters.fromDate.toString(),
            todate: filters.toDate.toString(),
        }
        try {
            const res = await axios.post(`${BASE_URL}/IB/ib_commission_report`, inputBody, { headers: getApiHeaders() });

            if (res.data.code === 200) {
                if (res.data.data.length === 0) {
                    setNoTableData(true);
                    setIbCommissionData([]);
                    return;
                }

                setNoTableData(false);
                setSearchQuery(searchTerm);
                setIbCommissionData(res.data.data)
            } else {
                MessageToster("error", res.data.message || "No data found.");
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    }

    const filteredData = ibCommissionData.filter((item) => {
        if (!searchQuery) return true;
        const query = searchQuery.toLowerCase();
        return (
            String(item.client_id || "").toLowerCase().includes(query) ||
            String(item.account_number || "").toLowerCase().includes(query) ||
            String(item.symbol || "").toLowerCase().includes(query) ||
            String(item.open_price || "").toLowerCase().includes(query) ||
            String(item.close_price || "").toLowerCase().includes(query) ||
            String(item.profit_loss || "").toLowerCase().includes(query) ||
            String(item.pip_size || "").toLowerCase().includes(query) ||
            String(item.spread || "").toLowerCase().includes(query) ||
            String(item.volume || "").toLowerCase().includes(query) ||
            String(item.level || "").toLowerCase().includes(query) ||
            String(item.level_commission || "").toLowerCase().includes(query) ||
            String(item.contract_size || "").toLowerCase().includes(query)
        );
    });

    return (
        <>
            <div id="layout-wrapper">
                {isPageLoading && <Loader />}
                <Topbar />
                <Sidebar />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h2 className="fw-700 mb-sm-0">
                                            IB Commission Report
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            {isActive && (
                                <>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                                                        <div>
                                                            <label htmlFor="">From</label>
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                name="fromDate"
                                                                value={filters.fromDate}
                                                                onChange={handleChange}
                                                                max={filters.toDate || today}
                                                                id="example-date-input"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">To</label>
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                name="toDate"
                                                                value={filters.toDate}
                                                                onChange={handleChange}
                                                                min={filters.fromDate || undefined}
                                                                max={today}
                                                                id="example-date-input"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">Client Id</label>
                                                            <select
                                                                className="form-select"
                                                                name="clientId"
                                                                value={filters.clientId}
                                                                onChange={(e) => handleClientSelect(e.target.value)}
                                                            >
                                                                <option value="" disabled hidden>
                                                                    {clientIds && clientIds.length > 0 ? "Select Client" : "No client found"}
                                                                </option>
                                                                {clientIds && clientIds.length > 0 ? (
                                                                    clientIds.map((client, index) => (
                                                                        <option key={index} value={client.client_id}>
                                                                            {client.client_id}
                                                                        </option>
                                                                    ))
                                                                ) : (
                                                                    <option value="" disabled>No client found</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">Account No</label>
                                                            <select
                                                                className="form-select"
                                                                name="account"
                                                                value={filters.account}
                                                                onChange={(e) =>
                                                                    setFilters({ ...filters, account: e.target.value })
                                                                }
                                                                disabled={!filters.clientId}
                                                            >
                                                                <option value="" disabled hidden>
                                                                    {accounts.length > 0 ? "Select Account" : "No Account Found"}
                                                                </option>
                                                                {accounts.length > 0 ? (
                                                                    accounts.map((acc, index) => (
                                                                        <option key={index} value={acc.account_number}>
                                                                            {acc.account_number}
                                                                        </option>
                                                                    ))
                                                                ) : (
                                                                    <option disabled>No accounts available</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">Search</label>
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Search..."
                                                                value={searchTerm}
                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                            />
                                                        </div>
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary waves-effect waves-light"
                                                                onClick={() => getIbCommissionData()}
                                                            >
                                                                Search
                                                            </button>
                                                        </div>
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary waves-effect waves-light"
                                                                onClick={clearFilters}
                                                                disabled={!filters.fromDate && !filters.toDate && !filters.clientId && !searchTerm}
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>
                                                        <div className="ms-auto">
                                                            <ExportButton
                                                                disabled={!ibCommissionData || ibCommissionData.length === 0}
                                                                onClick={() => { exportToExcel(ibCommissionData, "ib_commission", "ib_commission_report") }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <MobileFilter
                                                        title="History"
                                                        onExport={() => { exportToExcel(ibCommissionData, "ib_commission", "ib_commission_report") }}
                                                        exportDisabled={!ibCommissionData || ibCommissionData.length === 0}
                                                    >
                                                        <div>
                                                            <label htmlFor="">From</label>
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                name="fromDate"
                                                                value={filters.fromDate}
                                                                onChange={handleChange}
                                                                max={filters.toDate || today}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">To</label>
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                name="toDate"
                                                                value={filters.toDate}
                                                                onChange={handleChange}
                                                                min={filters.fromDate || undefined}
                                                                max={today}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">Client Id</label>
                                                            <select
                                                                className="form-select"
                                                                name="clientId"
                                                                value={filters.clientId}
                                                                onChange={(e) => handleClientSelect(e.target.value)}
                                                            >
                                                                <option value="" disabled hidden>
                                                                    {clientIds && clientIds.length > 0 ? "Select Client" : "No client found"}
                                                                </option>
                                                                {clientIds && clientIds.length > 0 ? (
                                                                    clientIds.map((client, index) => (
                                                                        <option key={index} value={client.client_id}>
                                                                            {client.client_id}
                                                                        </option>
                                                                    ))
                                                                ) : (
                                                                    <option value="" disabled>No client found</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">Account No</label>
                                                            <select
                                                                className="form-select"
                                                                name="account"
                                                                value={filters.account}
                                                                onChange={(e) =>
                                                                    setFilters({ ...filters, account: e.target.value })
                                                                }
                                                                disabled={!filters.clientId}
                                                            >
                                                                <option value="" disabled hidden>
                                                                    {accounts.length > 0 ? "Select Account" : "No Account Found"}
                                                                </option>
                                                                {accounts.length > 0 ? (
                                                                    accounts.map((acc, index) => (
                                                                        <option key={index} value={acc.account_number}>
                                                                            {acc.account_number}
                                                                        </option>
                                                                    ))
                                                                ) : (
                                                                    <option disabled>No accounts available</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="">Search</label>
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Search..."
                                                                value={searchTerm}
                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="d-flex gap-2 mt-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary waves-effect waves-light flex-grow-1"
                                                                onClick={() => getIbCommissionData()}
                                                                data-bs-dismiss="offcanvas"
                                                                data-bs-target="#filterOffcanvasMobile"
                                                            >
                                                                Search
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-light waves-effect waves-light border flex-grow-1"
                                                                onClick={clearFilters}
                                                                disabled={!filters.fromDate && !filters.toDate && !filters.clientId && !searchTerm}
                                                                data-bs-dismiss="offcanvas"
                                                                data-bs-target="#filterOffcanvasMobile"
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </MobileFilter>
                                                    <CommonTable
                                                        columns={[
                                                            { header: "Client ID", accessor: "client_id" },
                                                            { header: "Account Number", accessor: "account_number" },
                                                            { header: "Symbol", accessor: "symbol" },
                                                            { header: "Open time", render: (row) => row.open_time ? formatDateDDMMYYYY(row.open_time) : "-" },
                                                            { header: "Open Price", accessor: "open_price" },
                                                            { header: "Close Price", accessor: "close_price" },
                                                            { header: "Close time", render: (row) => row.close_time ? formatDateDDMMYYYY(row.close_time) : "-" },
                                                            { header: "Profit/Loss", accessor: "profit_loss" },
                                                            { header: "Pip Size", accessor: "pip_size" },
                                                            { header: "Spread", accessor: "spread" },
                                                            { header: "Volume", accessor: "volume" },
                                                            { header: "Level", accessor: "level" },
                                                            { header: "Level Commission", accessor: "level_commission" },
                                                            { header: "Contract Size", accessor: "contract_size" }
                                                        ]}
                                                        data={noTableData ? [] : filteredData}
                                                        loading={loading}
                                                    />
                                                </div>
                                            </div>
                                        </div>{" "}
                                    </div>
                                </>
                            )}

                            {isPending && (
                                <>
                                    <div className="row justify-content-center">
                                        <div
                                            className="alert alert-warning alert-dismissible fade show"
                                            role="alert"
                                            style={{
                                                marginBottom: "1.5rem",
                                            }}
                                        >
                                            <i className="mdi mdi-timer-sand-full me-2" />
                                            Your IB Account application status is <strong>pending</strong>. Please
                                            allow up to 24 hours for verification and approval.
                                        </div>
                                    </div>
                                </>
                            )}

                            {isNotApplied && (
                                <>
                                    <div className="row justify-content-center">
                                        <div
                                            className="alert alert-warning alert-dismissible fade show"
                                            role="alert"
                                            style={{
                                                marginBottom: "1.5rem",
                                            }}
                                        >
                                            <i className="mdi mdi-timer-sand-full me-2" />
                                            You have <strong>not applied</strong> for an IB Account yet.
                                            Please submit your IB application to get started.
                                        </div>
                                    </div>
                                    {/* <div className="row justify-content-center">
                                        <div className="alert alert-warning fade show d-flex justify-content-between align-items-center flex-wrap gap-3" style={{
                                            marginBottom: "1.5rem",
                                        }} role="alert">
                                            <p className="d-flex align-items-center mb-0"><i className="fa fa-info-circle fs-20 pe-2"></i>Looks like KYC documents are not uploaded, if the process is already done please allow up to 24 hours until the verification is complete.
                                            </p>
                                            <div>
                                                <button type="button"
                                                    className="btn btn-primary">Click Here</button>
                                            </div>
                                        </div>
                                    </div> */}
                                </>
                            )}
                        </div>
                    </div>
                    <Footer />
                </div>
            </div >
        </>
    );
}